export type ReceivingMethod =
  "" | "liftgate" | "customer_unload" | "dock_or_forklift";
export type DamagePolicy =
  "" | "accept_and_note_damage" | "refuse_severe_damage";

export type ShipmentCustomerNotificationPolicy = {
  receiving_method: ReceivingMethod;
  damage_policy: DamagePolicy;
  detention_policy: "" | "standard_weight_bands";
  detention_rate: string;
};

type Snapshot = Record<string, unknown> | null | undefined;

function storedPolicyValue(
  snapshot: Snapshot,
  key: string,
): { found: boolean; value?: unknown } {
  const policy = snapshot?.customer_notification_policy;
  if (!policy || typeof policy !== "object") return { found: false };
  if (!(key in policy)) return { found: false };
  const raw = (policy as Record<string, unknown>)[key];
  return {
    found: true,
    value:
      raw && typeof raw === "object" && "value" in raw
        ? (raw as { value?: unknown }).value
        : raw,
  };
}

export function shipmentCustomerNotificationPolicy(
  snapshot: Snapshot,
  override: Snapshot,
): ShipmentCustomerNotificationPolicy {
  const value = (key: string) => {
    const overridden = storedPolicyValue(override, key);
    return overridden.found
      ? overridden.value
      : storedPolicyValue(snapshot, key).value;
  };
  const receivingMethod = value("receiving_method");
  const damagePolicy = value("damage_policy");
  const detentionPolicy = value("detention_policy");
  const detentionRate = value("detention_rate");
  return {
    receiving_method:
      receivingMethod === "liftgate" ||
      receivingMethod === "customer_unload" ||
      receivingMethod === "dock_or_forklift"
        ? receivingMethod
        : "",
    damage_policy:
      damagePolicy === "accept_and_note_damage" ||
      damagePolicy === "refuse_severe_damage"
        ? damagePolicy
        : "",
    detention_policy:
      detentionPolicy === "standard_weight_bands" ? detentionPolicy : "",
    detention_rate: typeof detentionRate === "string" ? detentionRate : "",
  };
}
